<template>
  <div class="modal">
    <div class="modal-content">
        <button @click="close" class="modal-close is-large" aria-label="close"></button>
        <div style="position: relative; overflow: hidden; padding: 10px 20px; width: 100%; height: calc(100% - 1px);">
          <h1 style="font-weight: bold; font-size:20px;">
            DocHub Instructions
          </h1>
          <p>
            You can access the form using any email-enabled device; there is no charge, and no need to download the DocHub app itself. Here are the instructions:
          </p>
          <ol style="margin-left: 30px;">
            <li>You'll receive an email with the words <span style="font-weight: bold;">"ACTION NEEDED"</span> in the subject line (it might go into your junk/spam folder). Click or tap <span style="font-weight: bold;">"View Document"</span> to open each document.</li>
            <li>Click or tap to check the box that authorizes online signatures, and the <span style="font-weight: bold;">"let's do this"</span> button.</li>
            <li>Click or tap to open each required field (marked with an asterisk). Follow the prompts to complete each one.</li>
            <li>When all required fields are completed, a <span style="font-weight: bold;">"Finalize"</span> button will appear. Click that, and DocHub will email Excel the signed form (there is no need for you to send it to Excel). DocHub will also email you a signed copy for your files.</li>
            <li>We need only one copy returned to us, so if you return by email or fax, please ignore/delete the DocHub requests.</li>
            <li>You may also use the upload button to upload the file to your profile.</li>
          </ol>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
        }
    },
    methods: {
        close(){
            VueStore.dispatch('notify/setVariable', {key: 'viewDocHubInstructionModal', value: false});
        }
    }
}
</script>

<style scoped>
body{
    margin: 0px; background: #FFF !important; height: 100%;
}
.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-content{
    padding: 15px;
    top: 60px;
    width: 1000px;
    height: 800px;
    overflow: auto;
    background-clip: border-box !important;
}

.iframe-image{
    width: 920px;
    background-color: hsl(0, 0%, 90%);
    transition: background-color 300ms;
}

.iframe-pdf{
    width: 920px;
    height: 760px;
    -webkit-user-select: none;
    margin: auto;
    cursor: pointer;
    background-color: hsl(0, 0%, 90%);
    transition: background-color 300ms;
}

@media screen and (-webkit-min-device-pixel-ratio:0) {
    .iframe {
        zoom: 1;
    }
}

.modal-close.is-large {
    height: 42px;
    max-height: 42px;
    max-width: 42px;
    min-height: 42px;
    min-width: 42px;
    width: 42px;
}

.modal-close {
    z-index: 9999;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background-color: rgb(10 10 10 / 52%);
    border: none;
    border-radius: 290486px;
    cursor: pointer;
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 0;
    height: 20px;
    max-height: 20px;
    max-width: 20px;
    min-height: 20px;
    min-width: 20px;
    outline: none;
    vertical-align: top;
    width: 20px;
    height: 40px;
    right: 5px; 
    top: 5px;
    width: 40px;
    position: absolute;
}

@media screen and (min-width: 769px){
    .modal-content, .modal-card {
        margin: 0 auto;
        width: 950px !important;
    }
}
</style>